import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeleteOutlined, ExperimentOutlined, MenuOutlined } from "@ant-design/icons";
import { DndContext, PointerSensor, useSensor } from "@dnd-kit/core";
import { verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Button, Col, Form, Popconfirm, Row, Table } from "antd";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { useStores } from "../../../../../../../store/root.js";
import { spacing } from "../../../../../../../styles/spacing.js";
import { DraggableRow } from "../../../../../../third-party/dnd/draggable-row.js";
import { SortableList } from "../../../../../../third-party/dnd/sortable-list.js";
import { PermissionCheck } from "../../../../user/permission.js";
/**
 * Sortable table for dynamic fields with drag and drop support for reordering.
 */ const DynamicFieldsTable = ({ columns, formName = [], ...restProps })=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    const pointerSensor = useSensor(PointerSensor);
    return /*#__PURE__*/ _jsx(Form.List, {
        name: formName,
        children: (fields, { add, remove, move })=>{
            const tableColumns = [
                {
                    title: t("Sort"),
                    dataIndex: "sort",
                    width: 30,
                    render: ()=>/*#__PURE__*/ _jsx(MenuOutlined, {
                            style: {
                                cursor: "grab",
                                color: "#999"
                            }
                        })
                },
                ...columns
            ];
            if (hasCreatorRole) {
                tableColumns.push({
                    title: t("Action"),
                    dataIndex: "actions",
                    render: (_, record, index)=>{
                        return /*#__PURE__*/ _jsx(Popconfirm, {
                            placement: "leftTop",
                            title: t("Are you sure to delete this entry?"),
                            onConfirm: ()=>remove(index),
                            okText: t("Yes"),
                            cancelText: t("No"),
                            children: /*#__PURE__*/ _jsx(Button, {
                                icon: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                                onDoubleClick: ()=>remove(index)
                            })
                        });
                    }
                });
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(PermissionCheck, {
                        minRole: EUserRole.Creator,
                        children: /*#__PURE__*/ _jsx(Row, {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: spacing.layout.content.padding,
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsxs(Col, {
                                flex: 1,
                                style: {
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        onClick: ()=>add({
                                                name: null
                                            }),
                                        children: t("Add")
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        type: "link",
                                        icon: /*#__PURE__*/ _jsx(ExperimentOutlined, {}),
                                        children: /*#__PURE__*/ _jsx("a", {
                                            style: {
                                                paddingLeft: "5px"
                                            },
                                            href: "https://regex101.com/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: t("Test your expression")
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(DndContext, {
                        sensors: [
                            pointerSensor
                        ],
                        onDragEnd: (event)=>{
                            const from = fields.findIndex((field)=>field.key === +event.active.id);
                            const to = fields.findIndex((field)=>field.key === +event.over?.id);
                            move(from, to);
                        },
                        children: /*#__PURE__*/ _jsx(SortableList, {
                            fields: fields,
                            options: {
                                disabled: !hasCreatorRole,
                                strategy: verticalListSortingStrategy
                            },
                            children: /*#__PURE__*/ _jsx(Table, {
                                columns: tableColumns,
                                dataSource: fields,
                                components: {
                                    body: {
                                        row: DraggableRow
                                    }
                                },
                                pagination: false,
                                rowKey: "key",
                                ...restProps
                            })
                        })
                    })
                ]
            });
        }
    });
};
export { DynamicFieldsTable };
